// extracted by mini-css-extract-plugin
export default {"version-toggle":"VersionToggleButtons_version-toggle__SNvgY","disabled":"VersionToggleButtons_disabled__y-zWT"};